/**
 * Progress Bar component
 */

import React from 'react';

/**
 * Progress Bar component
 * @param {Object} props - Component props
 * @param {number} props.progress - Progress percentage (0-100)
 * @param {string} props.variant - Progress bar variant: 'primary', 'success', 'error'
 * @param {string} props.size - Progress bar size: 'sm', 'md', 'lg'
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.showLabel - Whether to show percentage label
 */
const ProgressBar = ({
  progress = 0,
  variant = 'primary',
  size = 'md',
  className = '',
  showLabel = false
}) => {
  // Clamp progress between 0 and 100
  const clampedProgress = Math.min(Math.max(progress, 0), 100);

  const variantClasses = {
    primary: 'bg-customOrange',
    success: 'bg-green-500',
    error: 'bg-red-500'
  };

  const sizeClasses = {
    sm: 'h-1',
    md: 'h-2',
    lg: 'h-3'
  };

  const baseClasses = 'w-full bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden';

  return (
    <div className={`${baseClasses} ${sizeClasses[size]} ${className}`}>
      <div
        className={`${variantClasses[variant]} transition-all duration-300 ease-out ${sizeClasses[size]} rounded-full`}
        style={{ width: `${clampedProgress}%` }}
        role="progressbar"
        aria-valuenow={clampedProgress}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        {showLabel && size !== 'sm' && (
          <span className="text-xs text-white font-medium px-2">
            {Math.round(clampedProgress)}%
          </span>
        )}
      </div>
    </div>
  );
};

export default ProgressBar;
